import { useEffect, useState } from "react";
import { api, inr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Building2, IndianRupee, TrendingUp, XCircle, Clock, Pause, AlertCircle, UserPlus } from "lucide-react";

const KPIS = [
  { key: "total_businesses", label: "Total Businesses", icon: Building2, format: (v) => v },
  { key: "active", label: "Active", icon: TrendingUp, format: (v) => v, color: "text-emerald-600" },
  { key: "trial", label: "On Trial", icon: Clock, format: (v) => v, color: "text-blue-600" },
  { key: "expired", label: "Expired", icon: XCircle, format: (v) => v, color: "text-rose-600" },
  { key: "cancelled", label: "Cancelled", icon: XCircle, format: (v) => v },
  { key: "suspended", label: "Suspended", icon: Pause, format: (v) => v, color: "text-orange-600" },
  { key: "mrr", label: "MRR", icon: IndianRupee, format: inr, color: "text-primary" },
  { key: "new_registrations", label: "New (30d)", icon: UserPlus, format: (v) => v },
  { key: "failed_payments", label: "Failed Payments", icon: AlertCircle, format: (v) => v, color: "text-rose-600" },
];

export default function AdminDashboard() {
  const [k, setK] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setK(r.data)); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);
  if (!k) return <div className="text-muted-foreground text-sm">Loading…</div>;
  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Admin Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-1">Real-time overview of all businesses on TheBillPro</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {KPIS.map((kpi) => (
          <Card key={kpi.key} className="p-5" data-testid={`admin-kpi-${kpi.key}`}>
            <div className={`w-9 h-9 rounded-lg bg-muted grid place-items-center mb-2 ${kpi.color || ""}`}>
              <kpi.icon size={16} />
            </div>
            <div className="text-xs uppercase tracking-widest text-muted-foreground">{kpi.label}</div>
            <div className="font-heading font-bold text-2xl mt-1">{kpi.format(k[kpi.key] ?? 0)}</div>
          </Card>
        ))}
      </div>
    </div>
  );
}
